<template>
  <section class="flex h-full grow flex-col justify-between space-y-6">
    <div class="flex grow flex-col space-y-12">
      <div class="space-y-4">
        <h2 class="text-text-neutral-primary text-2xl font-bold">
          {{ title }}
        </h2>
        <slot name="subtitle"></slot>
      </div>
      <div class="bg-situational-lightgrey mx-auto rounded-xl px-7 pb-8 pt-11">
        <picture>
          <source
            srcset="../../../assets/images/not-found-error.webp"
            type="image/webp"
          />
          <source
            srcset="../../../assets/images/not-found-error.png"
            type="image/png"
          />
          <img
            src="../../../assets/images/not-found-error.png"
            width="233"
            height="244"
            alt=""
          />
        </picture>
      </div>
    </div>
    <slot name="action"></slot>
  </section>
</template>

<script setup lang="ts">
  defineProps<{ title: string }>();
</script>
